import { TextField, useTheme } from "@mui/material";
import React, { forwardRef } from "react";
import { styled } from "@mui/material";

export const CustomTextInput = styled(TextField)({
  "& .MuiInputBase-input": {
    height: 40,
    boxSizing: "border-box",
    borderWidth: "1px",
    borderRadius: 4,
    border: "none !important",
    boxShadow: "0px 1px 1px 0px rgba(0,0,0,0.2)",
    ":required": {
      boxShadow: "0px 1px 1px 0px rgba(0,0,0,0.2)",
    },
    textOverflow: "ellipsis",
  },
});

const TextInput = forwardRef(function TextInput(props, ref) {
  const { id, placeholder, type, ...rest } = props;

  return (
    <CustomTextInput
      id={id}
      type={type}
      placeholder={placeholder}
      inputRef={ref}
      {...rest}
    />
  );
});

export default TextInput;
